import { AxiosCustomRequest } from '../types';
import { objectKeysToSnakeCase } from '../utils/objectKeysTo.js';

export function requestDataToSnakeCase(request: AxiosCustomRequest) {
  // Flag is flat-spread onto the axios config via upstream's makeConfig
  // from our fork's ClientOptions (`@mint-lib/api-zod-support`).
  const snakeCaseBody = (request as { request?: { snakeCaseBody?: boolean } })
    .request?.snakeCaseBody;
  if (snakeCaseBody === false) {
    return request;
  }

  if (request.headers?.['Content-Type'] === 'application/json') {
    return {
      ...request,
      data: objectKeysToSnakeCase(request.data),
    };
  }

  return request;
}
